// Unpublished Work © 2026 Deere & Company.

import {Config} from '../types/config-type';

export async function getBaseConfig(): Promise<Config> {
    const response = await fetch('/api/config');
    const baseConfig = await response.json();

    return baseConfig;
}
